document.addEventListener('DOMContentLoaded', function () {

  /*
   * Helper function
   */
  function pushToDataLayer(eventName, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...data
    });
  }

  /*
   * Size Guide Click
   */
  document.addEventListener('click', function (event) {
    const sizeGuideBtn = event.target.closest('.size-chart-link');
    if (sizeGuideBtn) {
      pushToDataLayer('size_guide_click', {
        product_name: window.productTitle || '',
        product_id: window.productId || '',
        page_url: window.location.href
      });
    }
  });
});